<template>
  <Details
    title="profiles template"
    resource="profileTemplates"
    :base-path="basePath"
    data-provider="$raaDataProvider"
    title-template="edit template {name}"
  >
    <template v-slot:side-panel>
      <DetailsSidePanel>
        <template v-slot:heading>template details</template>
        <template v-slot:text>Edit the profile data block template.</template>
      </DetailsSidePanel>
    </template>
    <template v-slot:default="detailsProps">
      <ProfileTemplateForm
        :initialValues="detailsProps.record"
        :on-submit="detailsProps.handleSubmit"
        :loading="detailsProps.loading"
        @close="detailsProps.redirectToList"
      />
    </template>
  </Details>
</template>

<script>
  import ModalNavigation from "@/mixins/ModalNavigation";
  import Details from "@/components/auth/details/Details";
  import DetailsSidePanel from "@/components/auth/details/DetailsSidePanel";
  import ProfileTemplateForm from "@/views/auth/raa-devtools/profiles/templates/ProfileTemplateForm";

  export default {
    name: "ProfileTemplateEdit",
    components: {
      ProfileTemplateForm,
      Details,
      DetailsSidePanel
    },
    mixins: [ModalNavigation],
    computed: {
      basePath: function () {
        return this.$route.name.replace('edit', 'index');
      }
    },
  }
</script>

<style scoped>

</style>
